import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  button: {
    background: "none",
    border: "none",
    cursor: "pointer"
  },
  pagecontent: {
    width: "100%",
    boxSizing: "border-box"
  }
}));
